import React, { useEffect, useState } from "react";
import { getDemoData, getSpecificFeed } from "../../../actions/feedActions";
import { Card, CardBody, Col, Media, Row } from "reactstrap";
import gifImage from "../../../public/images/Welcome-Banner.gif";
import gifImage2 from "../../../public/images/waitlistImg.gif";
import gifImage3 from "../../../public/images/classCancel.gif";
import eidBreakImg from "../../../public/images/eidBrek.gif";
import CrousalSlider from "./CrousalSlider";
import CrousalVideo from "./CrousalVideo";
import { getBaseUrl, daysNameEvaluation, monthNames } from "../../../actions/utility";
import ChaptersAccordion from "./feedComponents/ChaptersAccordion";
import DemoFeedback from "./feedComponents/DemoFeedback";
import ReScheduleDemo from "./feedComponents/ReScheduleDemo";
import TextMessageFeed from "./feedComponents/TextMessageFeed";
import * as Scroll from "react-scroll";
import StartClassFeed from "./feedComponents/StartClassFeed";
import yTubeIcon from "../../../public/images/youtubeIcon.svg";
import worksheetIcon from "../../../public/images/google-docs.png";
import plannerImage from "../../../public/images/Picture2.jpg";
import { Link } from "react-router-dom";
import PlannerDataFeed from "./feedComponents/PlannerDataFeed";
import ScoresFeedMerge from "./feedComponents/ScoresFeedMerge";
import $ from "jquery";
import UploadFeed from "./feedComponents/UploadFeed";
import StudentUploadFeed from "./feedComponents/StudentUploadFeed";
import TeacherUploadFeed from "./feedComponents/TeacherUploadFeed";
import UploadMultipleFeed from "./feedComponents/UploadMultipleFeed";
import StudentMultipleUploadFeed from "./feedComponents/StudentMultipleUploadFeed";
import TeacherUploadMultiple from "./feedComponents/TeacherUploadMultiple";
import InvoiceFeed from "./feedComponents/InvoiceFeed";

const DemoStudentView = (props) => {
  const [demoData, setdemoData] = useState();
  const [feedData, setfeedData] = useState([]);
  const [timeLeft, setTimeLeft] = useState("");
  const [timeLabel, settimeLabel] = useState("Class starts in");
  const [classStarted, setclassStarted] = useState(false);
  const [teacherName, setTeacherName] = useState("");
  const [teacherImg, setTeacherImg] = useState("");
  const [gradeName, setGradeName] = useState("");
  const [feedLoading, setfeedLoading] = useState(true);
  const [showChapters, setshowChapters] = useState(false);
  const [programId, setprogramId] = useState("");
  const [specificFeed, setspecificFeed] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [isLoading, setisLoading] = useState(false);
  const [isCopied, setisCopied] = useState(false);
  const [popup, setPopup] = useState(null);
  const [encryptedId, setEncryptedId] = useState('');

  useEffect(() => {
    setisLoading(true);
          // Extract the ID from the hash part of the URL
          const hash = window.location.hash;
          if (hash) {
            const encryptedId = hash.substring(2); // Remove the '#/' part
            setEncryptedId(encryptedId);
          }

    getDemoData(props.studentId, 2, currentPage)
      // getDemoData('O496mNWazVrpEvM', 2)
      .then((res) => {
        setisLoading(false);
        // debugger;
        if (res?.data?.result.length > 0) {
          setprogramId(res.data.result[0]["prog_id"]);
          setfeedData([...feedData, ...res.data.result]);
          setTeacherImg(res.data.result[0]["teacher_image"]);
          setTeacherName(res.data.result[0]["teacher_name"]);
          setGradeName(res.data.result[0]["course_name"]);
        }
        setfeedLoading(false);
        console.log("Home Feeds Data", res.data);
        // document.getElementById("cc").scrollIntoView({ behavior: "smooth" });

        if (props.feedId !== 0) {
          getSpecificFeed(props.studentId, 2, props.feedId)
            .then((res) => {
              setspecificFeed(res.data.result);
              debugger;
            })
            .catch((err) => {
              setspecificFeed({});
              debugger;
            });
          console.log("FeedID", props.feedId);
        } else {
          console.log("FeedID", props.feedId);
        }
      })
      .catch((err) => {
        setisLoading(false);
        setfeedData([]);
        debugger;
      });
    // window.location = getBaseUrl() + '/home/' + 'P9az3rY8xx2lAoQ';
  }, [currentPage]);

  const copyFunc = (studentId) => {
    navigator.clipboard.writeText(`https://lincolnmethod.com/?ref=${studentId}`);
    setisCopied(true);

    setTimeout(() => {
      setisCopied(false);
    }, 2000);
  };
  const calculateTimeLeft = (time) => {
    const difference = +new Date(time) - +new Date();
    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        d: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hrs: Math.floor((difference / (1000 * 60 * 60)) % 24),
        min: Math.floor((difference / 1000 / 60) % 60),
        sec: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };

  useEffect(() => {
    const difference =
      +new Date(feedData.length && feedData[0]["scheduled_date_time"]) - +new Date();
    if (difference > 0) {
      setTimeout(() => {
        setTimeLeft(calculateTimeLeft(feedData.length && feedData[0]["scheduled_date_time"]));
        // setTimeLeft(calculateTimeLeft("2021-08-11 11:49:00"));
      }, 1000);
    } else {
      settimeLabel("");
    }
  });
  const timerComponents = [];

  if (typeof timeLeft !== "undefined") {
    // debugger;
    Object.keys(timeLeft).forEach((interval) => {
      if (!timeLeft[interval]) {
        return;
      }
      console.log("Time Left", timeLeft);
      // if (timeLeft.days == 0 && timeLeft.hours == 0 && timeLeft.minutes <= 10 && count) {
      //     debugger;
      //     setstartButton(false);
      //     setcount(false);
      // }
      timerComponents.push(
        <span className="mt-2 text-success">
          {timeLeft[interval]}
          {interval} &nbsp;
        </span>
      );
    });
    if (
      Object.keys(timeLeft).length === 0 &&
      timeLeft.constructor === Object &&
      timerComponents.length == 0 &&
      !classStarted
    ) {
      debugger;
      settimeLabel("Class Started");
      setclassStarted(true);
      // setpostBtnClicked(false)
      // window.open(zoomLink, '_blank');
      // setTimeLeft('');
      // $('#myModalWait').modal('hide');
    }
  }

  const images = [
    {
      original: require("../../../public/images/DashboardUser/1.png"),
      thumbnail: require("../../../public/images/DashboardUser/1.png"),
    },
    {
      original: require("../../../public/images/DashboardUser/2.png"),
      thumbnail: require("../../../public/images/DashboardUser/2.png"),
    },
    {
      original: require("../../../public/images/DashboardUser/3.png"),
      thumbnail: require("../../../public/images/DashboardUser/3.png"),
    },
    {
      original: require("../../../public/images/DashboardUser/4.png"),
      thumbnail: require("../../../public/images/DashboardUser/4.png"),
    },
    {
      original: require("../../../public/images/DashboardUser/5.png"),
      thumbnail: require("../../../public/images/DashboardUser/5.png"),
    },
    {
      original: require("../../../public/images/DashboardUser/6.png"),
      thumbnail: require("../../../public/images/DashboardUser/6.png"),
    },
    {
      original: require("../../../public/images/DashboardUser/7.png"),
      thumbnail: require("../../../public/images/DashboardUser/7.png"),
    },
    {
      original: require("../../../public/images/DashboardUser/8.png"),
      thumbnail: require("../../../public/images/DashboardUser/8.png"),
    },
    {
      original: require("../../../public/images/DashboardUser/9.png"),
      thumbnail: require("../../../public/images/DashboardUser/9.png"),
    },
    {
      original: require("../../../public/images/DashboardUser/10.png"),
      thumbnail: require("../../../public/images/DashboardUser/10.png"),
    },
    {
      original: require("../../../public/images/DashboardUser/11.png"),
      thumbnail: require("../../../public/images/DashboardUser/11.png"),
    },
  ];

  const TDate = (scheduledTime) => {
    var ToDate = new Date();

    if (new Date(scheduledTime).getTime() <= ToDate.getTime()) {
      // alert("The Date must be Bigger or Equal to today date");
      return true;
    }
    return false;
  };

  const openFacebookPopup = () => {
    const width = 600;
    const height = 400;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    const url = "https://www.facebook.com";

    const options = `width=${width},height=${height},left=${left},top=${top}`;

    const popupWindow = window.open(url, "Facebook", options);
    setPopup(popupWindow);
  };
  const openInstaPopup = () => {
    const width = 600;
    const height = 400;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    const url = "https://www.instagram.com";

    const options = `width=${width},height=${height},left=${left},top=${top}`;

    const popupWindow = window.open(url, "Facebook", options);
    setPopup(popupWindow);
  };
  const openLinkedInPopup = () => {
    const width = 600;
    const height = 400;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    const url = "https://www.linkedIn.com";

    const options = `width=${width},height=${height},left=${left},top=${top}`;

    const popupWindow = window.open(url, "Facebook", options);
    setPopup(popupWindow);
  };

  const openWhatsAppPopup = (studentId) => {
    const content = `I found this service that has online tutors, check it out: \n \nhttps://lincolnmethod.com/?ref=${studentId}`;
    const image =
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c2Nob29sfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60";
    const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(
      content
    )}&media=${encodeURIComponent(image)}`;
    window.open(url, "_blank");
  };

  console.log("Time Left", timeLeft);
  console.log("Feed Data", feedData);
  return !feedLoading ? (
    <React.Fragment>
      {props.feedId > 0 ? (
        specificFeed?.feed_label == "start_class" ? (
          <StartClassFeed item={specificFeed} rewardPrice={props.rewardPrice} />
        ) : specificFeed?.feed_label === "message_text" ? (
          <TextMessageFeed item={specificFeed} />
        ) : specificFeed?.feed_label === "planner_data" ? (
          <PlannerDataFeed item={specificFeed} />
        ) : null
      ) : (
        <>
          {/* <UploadFeed studentId={props.studentId} programs={props?.programs} /> */}
          <UploadMultipleFeed studentId={props.studentId} programs={props?.programs} />
          {feedData.map((item, index) =>
            item.feed_label === "welcome_message" ? (
              <Card
                key={index}
                style={{
                  marginBottom: "2vh",
                  border: "1px #ccc solid",
                  textAlign: "left",
                }}
                className="homeSection"
                id={item.user_feedid}
              >
                <CardBody>
                  <div className="d-flex tutorImageSection">
                    <div>
                      <img
                        className=""
                        src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.teacher_image}`}
                        width="40"
                        height="40"
                      />
                    </div>
                    <div className="ml-2">
                      <label>
                        {item.teacher_name}
                        <strong> welcomes</strong> you
                      </label>{" "}
                      <br />
                      <span className="gradeName text-primary">{item.course_name}</span>
                    </div>
                  </div>
                  <div className="mt-3">
                    <label>Welcome! You have signed up successfully</label>
                  </div>
                  <div className="border text-center">
                    <img src={gifImage} width="100%" />
                    <div className="referraLinkBtn" style={{textAlign: 'right !important', display: 'flex', justifyContent: 'flex-end'}}>
                      <button
                        className={isCopied ? "btn btn-sm btn-success" : "btn btn-sm btn-warning"}
                        onClick={() => {
                          $("#referralPopup").modal("show");
                        }}
                        style={{ fontSize: 12 }}
                      >
                        Invite a friend
                        <svg
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          viewBox="0 0 501.2 647.8"
                          style={{ enableBackground: 'new 0 0 501.2 647.8', height: "3em"}}
                          xmlSpace="preserve"
                          className="svg-icon"
                        >
                          <style>
                            {`
                              .st0{fill:#135D7A;stroke:#135D7A;stroke-width:11;stroke-miterlimit:10;}
                              .st1{fill:#135D7A;stroke:#135D7A;stroke-width:22;stroke-miterlimit:10;}
                              .st2{fill:none;stroke:#135D7A;stroke-width:12;stroke-miterlimit:10;}
                              .st3{fill:#231F20;}
                              .st4{fill:none;stroke:#135D7A;stroke-width:31;stroke-miterlimit:10;}
                            `}
                          </style>
                          <path className="st0" d="M290.2,86.4h-79.1c-1.8,0-3.1-1.5-3.1-3.1v-10c0-1.8,1.5-3.1,3.1-3.1h79.1c1.8,0,3.1,1.5,3.1,3.1v10
                            C293.2,85.1,292,86.4,290.2,86.4z"/>
                          <rect x="93.2" y="515.9" className="st1" width="314.8" height="9.2"/>
                          <circle className="st2" cx="250.6" cy="574.4" r="23.5"/>
                          <path className="animated-icon st3" d="M252.4,307.3c-30.3-3.5-34.4-17.9-34.4-32.6c0-17.9,14.7-32.6,32.6-32.6s32.6,14.7,32.6,32.6
                            c0,9.3,7.3,16.6,16.6,16.6s16.6-7.3,16.6-16.6c0-30.6-21-56.1-49.2-63.6v-7.9c0-9.3-7.3-16.6-16.6-16.6c-9.3,0-16.6,7.3-16.6,16.6
                            v7.9c-28.1,7.3-49.2,33.1-49.2,63.6c0,21.7,8.3,59.1,63.9,65.7c30.3,3.5,34.4,17.9,34.4,32.6c0,17.9-14.7,32.6-32.6,32.6
                            c-17.9,0-32.6-14.7-32.6-32.6c0-9.3-7.3-16.6-16.6-16.6c-9.3,0-16.6,7.3-16.6,16.6c0,30.6,21,56.1,49.2,63.6v7.9
                            c0,9.3,7.3,16.6,16.6,16.6c9.3,0,16.6-7.3,16.6-16.6v-7.9c28.1-7.3,49.2-33.1,49.2-63.6C316.1,351.4,307.9,314.1,252.4,307.3z"/>
                          <g>
                            <path className="st4" d="M392.4,627.4H108.8c-22.4,0-40.5-18.1-40.5-40.5v-526c0-22.4,18.1-40.5,40.5-40.5h283.6
                              c22.4,0,40.5,18.1,40.5,40.5v526C432.9,609.3,414.8,627.4,392.4,627.4z"/>
                          </g>
                        </svg>
                      </button>
                    </div>
                  </div>
                  {TDate(item.scheduled_date_time) ? (
                    <div className="mt-3">
                      <label className="font-weight-bold">Your class was on:</label>
                      <p>
                        Date: {daysNameEvaluation[new Date(item.scheduled_date_time).getDay()]}{" "}
                        {new Date(item.scheduled_date_time).getDate()}{" "}
                        {monthNames[new Date(item.scheduled_date_time).getMonth()]} <br />
                        Time:{" "}
                        {new Date(item.scheduled_date_time).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}{" "}
                        <br />
                        Teacher: {item.teacher_name}{" "}
                      </p>
                    </div>
                  ) : (
                    <>
                      <div className="mt-3">
                        <label className="font-weight-bold">Your class is on:</label>
                        <p>
                          Date: {daysNameEvaluation[new Date(item.scheduled_date_time).getDay()]}{" "}
                          {new Date(item.scheduled_date_time).getDate()}{" "}
                          {monthNames[new Date(item.scheduled_date_time).getMonth()]} <br />
                          Time:{" "}
                          {new Date(item.scheduled_date_time).toLocaleTimeString("en-US", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}{" "}
                          <br />
                          Teacher: {item.teacher_name}{" "}
                        </p>
                      </div>
                      <button
                        className="btn btn-success zoomBtn"
                        onClick={() => window.open(item.zoomlink, "_blank")}
                      >
                        Click to join your class online
                      </button>
                    </>
                  )}
                  <label>
                    {timeLabel} {timerComponents}
                  </label>{" "}
                  <br />
                </CardBody>
                <div className="zoomSection">
                  {/* <label>{timeLabel} {timerComponents}</label> <br />
                                <button className="btn btn-success zoomBtn" onClick={() => window.open(item.zoomlink, '_blank')}>Click to join your class online</button> */}
                </div>
              </Card>
            ) : item.feed_label === "waiting_list" ? (
              <Card
                key={index}
                style={{
                  marginBottom: "2vh",
                  border: "1px #ccc solid",
                  textAlign: "left",
                }}
                className="homeSection"
                id={item.user_feedid}
              >
                <CardBody>
                  <div className="d-flex tutorImageSection">
                    <div>
                      <img
                        className=""
                        src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.teacher_image}`}
                        width="40"
                        height="40"
                      />
                    </div>
                    <div className="ml-2">
                      <label>
                        {item.teacher_name}
                        <strong> welcomes</strong> you
                      </label>{" "}
                      <br />
                      <span className="gradeName text-muted">{item.course_name}</span>
                    </div>
                  </div>
                  <div className="mt-3">
                    <label>Congratulations! You have signed up successfully</label>
                  </div>
                  <div className="border text-center">
                    <img src={gifImage2} width="100%" />
                  </div>
                  <div className="mt-3">
                    <label>
                      You have been added to the Waiting Room because this class is full
                    </label>
                  </div>
                  {/* <button className="btn btn-success zoomBtn" onClick={() => window.open(`https://dashboard.lincolnmethod.com/signin?continue_session=true&student_id=${props.studentId}`, '_blank')}>Take a practice test while you wait</button> */}
                  <button
                    className={showChapters ? "btn takeTest mt-3" : "btn btn-success zoomBtn mt-3"}
                    onClick={() => setshowChapters(!showChapters)}
                  >
                    {showChapters
                      ? "Select a chapter and a topic below"
                      : "Take a practice test while you wait"}
                  </button>
                  {showChapters ? (
                    <ChaptersAccordion programId={item.prog_id} studentId={props.studentId} />
                  ) : null}
                </CardBody>
                <div className="zoomSection">
                  {/* <label>{timeLabel} {timerComponents}</label> <br /> */}
                  {/* <button className="btn btn-success zoomBtn" onClick={() => window.open(getBaseUrl() + '/home/' + props.studentId, '_blank')}>Take a practice test</button> */}
                </div>
              </Card>
            ) : item.feed_label === "demo_feedback" ? (
              <Card
                key={index}
                style={{
                  marginBottom: "2vh",
                  border: "1px #ccc solid",
                  textAlign: "left",
                }}
                className="homeSection"
                id={item.user_feedid}
              >
                <CardBody>
                  <div className="d-flex tutorImageSection">
                    <div>
                      <img
                        className=""
                        src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.teacher_image}`}
                        width="40"
                        height="40"
                      />
                    </div>
                    <div className="ml-2">
                      <label>
                        {item.teacher_name}
                        <strong> gave</strong> feedback
                      </label>{" "}
                      <br />
                      <span className="gradeName text-muted">{item.course_name}</span>
                    </div>
                  </div>

                  <DemoFeedback
                    feedData={JSON.parse(item.feed_data)}
                    courseId={item.course_id}
                    programId={item.prog_id}
                    studentId={item.student_id}
                    studentName={item.student_name}
                  />
                </CardBody>
                <div className="zoomSection">
                  {/* <label>{timeLabel} {timerComponents}</label> <br /> */}
                  {/* <button className="btn btn-success zoomBtn" onClick={() => window.open(getBaseUrl() + '/home/' + props.studentId, '_blank')}>Take a practice test</button> */}
                </div>
              </Card>
            ) : item.feed_label === "demo_class_cancel" ? (
              <Card
                key={index}
                style={{
                  marginBottom: "2vh",
                  border: "1px #ccc solid",
                  textAlign: "left",
                }}
                className="homeSection"
                id={item.user_feedid}
              >
                <CardBody>
                  <div className="d-flex tutorImageSection">
                    <div>
                      <img
                        className=""
                        src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.teacher_image}`}
                        width="40"
                        height="40"
                      />
                    </div>
                    <div className="ml-2">
                      <label>
                        {item.teacher_name}
                        <strong> Cancelled</strong> class for
                      </label>{" "}
                      <br />
                      <span className="gradeName text-muted">{item.course_name}</span>
                    </div>
                  </div>

                  <div className="border text-center mt-3">
                    <img src={gifImage3} width="100%" />
                  </div>
                  <div className="mt-3">
                    <label>
                      Class cancel{" "}
                      {JSON.parse(item.feed_data).map((item, index) => (
                        <span key={index} className="font-weight-bold text-lowercase">
                          {item.reason}{" "}
                        </span>
                      ))}
                    </label>
                  </div>

                  <ReScheduleDemo
                    id={index}
                    courseId={item.course_id}
                    programName={item.course_name}
                  />
                  <button
                    className={showChapters ? "btn takeTest mt-3" : "btn btn-success zoomBtn mt-3"}
                    onClick={() => setshowChapters(!showChapters)}
                  >
                    {showChapters
                      ? "Select a chapter and a topic below"
                      : "Take a practice test while you wait"}
                  </button>
                  {showChapters ? (
                    <ChaptersAccordion programId={item.prog_id} studentId={props.studentId} />
                  ) : null}
                </CardBody>
                <div className="zoomSection">
                  {/* <label>{timeLabel} {timerComponents}</label> <br /> */}
                  {/* <button className="btn btn-success zoomBtn" onClick={() => window.open(getBaseUrl() + '/home/' + props.studentId, '_blank')}>Take a practice test</button> */}
                </div>
              </Card>
            ) : item.feed_label === "reg_class_cancel" ? (
              <Card
                key={index}
                style={{
                  marginBottom: "2vh",
                  border: "1px #ccc solid",
                  textAlign: "left",
                }}
                className="homeSection"
                id={item.user_feedid}
              >
                <CardBody>
                  <div className="d-flex tutorImageSection">
                    <div>
                      <img
                        className=""
                        src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.teacher_image}`}
                        width="40"
                        height="40"
                      />
                    </div>
                    <div className="ml-2">
                      <label>
                        {item.teacher_name}
                        <strong> Cancelled</strong> class for
                      </label>{" "}
                      <br />
                      <span className="gradeName text-muted">{item.course_name}</span>
                    </div>
                  </div>

                  <div className="border text-center mt-3">
                    <img src={gifImage3} width="100%" />
                  </div>
                  <div className="mt-3">
                    <label>
                      Class cancelled{" "}
                      {JSON.parse(item.feed_data).map((item, index) => (
                        <span key={index} className="font-weight-bold text-lowercase">
                          {item.reason}{" "}
                        </span>
                      ))}
                    </label>
                  </div>
                  <button
                    className={showChapters ? "btn takeTest mt-3" : "btn btn-success zoomBtn mt-3"}
                    onClick={() => setshowChapters(!showChapters)}
                  >
                    {showChapters
                      ? "Select a chapter and a topic below"
                      : "Take a practice test while you wait"}
                  </button>
                  {showChapters ? (
                    <ChaptersAccordion programId={item.prog_id} studentId={props.studentId} />
                  ) : null}
                </CardBody>
                <div className="zoomSection">
                  {/* <label>{timeLabel} {timerComponents}</label> <br /> */}
                  {/* <button className="btn btn-success zoomBtn" onClick={() => window.open(getBaseUrl() + '/home/' + props.studentId, '_blank')}>Take a practice test</button> */}
                </div>
              </Card>
            ) : item.feed_label === "course_question" ? (
              <Card
                style={{
                  marginBottom: "2vh",
                  border: "1px #ccc solid",
                  textAlign: "left",
                }}
                className="homeSection"
                id={item.user_feedid}
              >
                <CardBody>
                  <div className="d-flex tutorImageSection">
                    <div>
                      <img
                        className=""
                        src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${teacherImg}`}
                        width="40"
                        height="40"
                      />
                    </div>
                    <div className="ml-2">
                      <label>
                        {teacherName}
                        <strong> shares</strong> question
                      </label>{" "}
                      <br />
                      <span className="gradeName text-muted">{gradeName}</span>
                    </div>
                  </div>

                  <div className="text-center">
                    {/* <img className='img-thumbnail mt-4' src="https://lincolnmethod.s3.amazonaws.com/curriculums/curriculum_228_1640333765_up_717654734.jpg" width="100%" height="300" /> */}
                    {item.feed_data && item.feed_data ? (
                      <img
                        className="img-thumbnail mt-4"
                        src={JSON.parse(item.feed_data)["imageurl"]}
                        width="100%"
                        height="300"
                      />
                    ) : null}
                  </div>
                </CardBody>
              </Card>
            ) : item.feed_label === "before_after" ? (
              <Card
                style={{
                  marginBottom: "2vh",
                  border: "1px #ccc solid",
                  textAlign: "left",
                }}
                className="homeSection"
                id={item.user_feedid}
              >
                <CardBody>
                  <div className="d-flex tutorImageSection">
                    <div>
                      <img
                        className=""
                        src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${teacherImg}`}
                        width="40"
                        height="40"
                      />
                    </div>
                    <div className="ml-2">
                      <label>
                        {teacherName}
                        <strong> shares</strong> success stories
                      </label>{" "}
                      <br />
                      <span className="gradeName text-muted">{gradeName}</span>
                    </div>
                  </div>

                  <label className="mt-4">You can succeed like these Students too</label>
                  {JSON.parse(item.feed_data).length > 0 ? (
                    <CrousalSlider feedFor="before_after" images={JSON.parse(item.feed_data)} />
                  ) : null}

                  <button
                    className={showChapters ? "btn takeTest mt-3" : "btn btn-success zoomBtn mt-3"}
                    onClick={() => setshowChapters(!showChapters)}
                  >
                    {showChapters
                      ? "Select a chapter and a topic below"
                      : "Take a practice test while you wait"}
                  </button>
                  {showChapters ? (
                    <ChaptersAccordion programId={item.prog_id} studentId={props.studentId} />
                  ) : null}
                </CardBody>
                <div className="zoomSection">
                  {/* <label>Class starts in 12 min</label> <br /> */}
                </div>
              </Card>
            ) : item.feed_label === "message_text" || item?.feed_label === "teacher_message_text" ? (
              <TextMessageFeed item={item} />
            ) : item.feed_label === "start_class" ? (
              <StartClassFeed item={item} rewardPrice={props.rewardPrice} />
            ) : item.feed_label === "planner_data" ? (
              <PlannerDataFeed item={item} />
            ) : item.feed_label === "score" ? (
              <ScoresFeedMerge studentInfo={props.studentInfo} item={JSON.parse(item.feed_data)} />
            ) : item.feed_label === "student_upload" ? (
              <StudentUploadFeed item={item} />
            ) : item.feed_label === "teacher_upload" ? (
              <TeacherUploadFeed item={item} />
            ) : item.feed_label === "teacher_upload_multiple" ? (
              <TeacherUploadMultiple item={item} />
            ) : item.feed_label === "student_upload_multiple" ? (
              <StudentMultipleUploadFeed item={item} />
            ) : item?.feed_label === "invoice" ? (
              <InvoiceFeed item={item} />
            ) : null
          )}
        </>
      )}
      {props.feedId > 0 ? (
        <Link to={`/${props.studentId}`}>
          {" "}
          <button className="btn btn-light mb-5 btn-sm w-50">See all</button>
        </Link>
      ) : ( null
        // <>
        //   {/* Success stories card */}
        //   <Card
        //     style={{
        //       marginBottom: "2vh",
        //       border: "1px #ccc solid",
        //       textAlign: "left",
        //     }}
        //     className="homeSection"
        //   >
        //     <CardBody>
        //       <div className="d-flex tutorImageSection">
        //         <div>
        //           <img
        //             className=""
        //             src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${teacherImg}`}
        //             width="40"
        //             height="40"
        //           />
        //         </div>
        //         <div className="ml-2">
        //           <label>
        //             {teacherName}
        //             <strong> shares</strong> images
        //           </label>{" "}
        //           <br />
        //           <span className="gradeName text-muted">{gradeName}</span>
        //         </div>
        //       </div>

        //       <div className="text-center">
        //         {/* <img className='img-thumbnail mt-4' src="https://lincolnmethod.s3.amazonaws.com/beforeAfter_of_course/beforeafter_214_1622792080_up_250743068.jpeg" width="100%" height="300" /> */}
        //         {/* <img className='img-thumbnail mt-2' src="https://lincolnmethod.s3.amazonaws.com/beforeAfter_of_course/beforeafter_214_1622792087_up_952289271.jpeg" width="300" height="300" /> */}
        //       </div>
        //       <CrousalSlider feedFor="video_testimonial" images={images} />
        //       <button
        //         className={showChapters ? "btn takeTest mt-3" : "btn btn-success zoomBtn mt-3"}
        //         onClick={() => setshowChapters(!showChapters)}
        //       >
        //         {showChapters
        //           ? "Select a chapter and a topic below"
        //           : "Take a practice test while you wait"}
        //       </button>
        //       {showChapters ? (
        //         <ChaptersAccordion programId={programId} studentId={props.studentId} />
        //       ) : null}
        //     </CardBody>
        //     <div className="zoomSection">{/* <label>Class starts in 12 min</label> <br /> */}</div>
        //   </Card>  

        //   {/* Video Testimonial card */}
        //   {/* <Card
        //     style={{
        //       marginBottom: "2vh",
        //       border: "1px #ccc solid",
        //       textAlign: "left",
        //     }}
        //     className="homeSection hamza"
        //     name="hamza"
        //   >
        //     <CardBody>
        //       <div className="d-flex tutorImageSection">
        //         <div>
        //           <img
        //             className=""
        //             src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${teacherImg}`}
        //             width="40"
        //             height="40"
        //           />
        //         </div>
        //         <div className="ml-2" id="cc">
        //           <label>
        //             {teacherName}
        //             <strong> shares</strong> video testimonials
        //           </label>{" "}
        //           <br />
        //           <span className="gradeName text-muted">{gradeName}</span>
        //         </div>
        //       </div>

        //       <div className="text-left">
        //         <label className="mt-4">
        //           Watch these video testimonials from Parents and Students like you
        //         </label>
        //         <div>
        //           <CrousalVideo />
        //         </div>
        //       </div>
        //     </CardBody>
        //   </Card> */}
        // </>
      )}

      <div className="modalForZoomLink">
        <div className="modal fade" tabIndex="-1" role="dialog" id="referralPopup">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <div className="text-center">
                  <i className="fas fa-share-alt fa-2x text-success"></i>
                  <h5 className="font-weight-bold mt-1">Share your unique link</h5>
                  <div className="text-center">
                    <p>{`https://lincolnmethod.com/?ref=${encryptedId}`}</p>
                    <button
                      className="btn btn-success btn-sm"
                      onClick={() => copyFunc(props.studentId)}
                    >
                      {isCopied ? "Copied!" : "Copy"}
                    </button>

                    <h5 className="font-weight-bold mt-1">Share on social media</h5>
                    <div className="d-flex justify-content-center">
                      <button className="fbBtn mx-2" onClick={openFacebookPopup}>
                        <i className="fa fa-facebook" />
                      </button>

                      <button className="instaBtn mx-2" onClick={openInstaPopup}>
                        <i className="fa fa-instagram" />
                      </button>
                      <button className="linkedInBtn mx-2" onClick={openLinkedInPopup}>
                        <i className="fa fa-linkedin" />
                      </button>
                      <button
                        className="whatsappInBtn mx-2"
                        onClick={() => openWhatsAppPopup(encryptedId)}
                      >
                        <i className="fa fa-whatsapp" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div>
        <button
          className="btn btn-warning btn-sm mb-5"
          onClick={() => setcurrentPage(currentPage + 1)}
        >
          Load More
          {isLoading ? (
            <div className="spinner-border spinner-border-sm ml-2" role="status">
              <span className="sr-only mt-2">Loading...</span>
            </div>
          ) : (
            <i className="fa fa-chevron-down ml-2"></i>
          )}
        </button>
      </div>
    </React.Fragment>
  ) : (
    <div className="spinner-border spinner-border-md mt-5" role="status">
      <span className="sr-only mt-2">Loading...</span>
    </div>
  );
};

export default DemoStudentView;
